import React, { Component } from 'react'
import InputNumber from 'rc-input-number'
import _ from 'lodash'

import ItemSmartSuggestionTable from '../ItemSmartSuggestionTable/ItemSmartSuggestionTable'

export default class SmartInputNumber extends Component {
    constructor(props) {
        super(props)

        this.state = {
            tableVisible: false,
            tableFocused: false
        }

        this.handleFocus = this.handleFocus.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
        this.handleDocumentMouseDown = this.handleDocumentMouseDown.bind(this)
        this.handleMouseDown = this.handleMouseDown.bind(this)
        this.handleTableRowClick = this.handleTableRowClick.bind(this)
    }

    handleFocus(e) {
        const { onFocusFetcher, isSmartSuggestionDisabled, itemName } = this.props

        if (!isSmartSuggestionDisabled && itemName) {
            onFocusFetcher()
            this.setState({ tableVisible: true })
        }
    }

    handleBlur(e) {
        const { isSmartSuggestionDisabled } = this.props
        const { tableFocused } = this.state
        if (!isSmartSuggestionDisabled && !tableFocused)
            this.setState({ tableVisible: false })
    }

    handleDocumentMouseDown(e) {
        this.setState({ tableVisible: false, tableFocused: false })
    }

    handleMouseDown(e) {
        e.stopPropagation()
        e.nativeEvent.stopImmediatePropagation()
        this.setState({ tableFocused: true })
    }

    handleTableRowClick(selectedItem) {
        const { onRowClick } = this.props
        onRowClick(selectedItem)
        this.setState({ tableVisible: false })
    }

    componentDidMount() {
        const { isSmartSuggestionDisabled } = this.props
        if (!isSmartSuggestionDisabled)
            document.addEventListener('mousedown', this.handleDocumentMouseDown)
    }

    componentWillUnmount() {
        const { isSmartSuggestionDisabled } = this.props
        if (!isSmartSuggestionDisabled)
            document.removeEventListener('mousedown', this.handleDocumentMouseDown)
    }

    render() {
        const { onRowClick, onFocusFetcher, itemName, itemSmartSuggestionList, isSmartSuggestionDisabled, ...props } = this.props
        const { tableVisible } = this.state

        return (
            <div>
            	<InputNumber 
            		onFocus={this.handleFocus} 
            		onBlur={this.handleBlur}
            		{...props}
            	/>
        		<ItemSmartSuggestionTable 
        			onMouseDown={this.handleMouseDown}
        			onRowClick={(selectedItem) => this.handleTableRowClick(selectedItem)}
        			visible={tableVisible} 
        			dataSource={itemSmartSuggestionList}
        		/>
        	</div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/SmartInputNumber/SmartInputNumber.js